import type React from 'react';
import { useSelector } from 'react-redux';
import { getProjectState } from '../../selectors.js';
import DocumentTitle, { type DocumentTitleOwnProps, type DocumentTitleStateProps } from './document-title.js';

function useDocumentTitle(): DocumentTitleStateProps {
  const project = useSelector(getProjectState);
  return {
    projectName: project.loaded && project.data ? project.data.get('name') : ''
  };
}

const DocumentTitleContainer: React.FC<DocumentTitleOwnProps> = (props) => {
  const stateProps = useDocumentTitle();
  return <DocumentTitle {...props} {...stateProps} />;
};

export default DocumentTitleContainer;
